// authenticated.js

export const authenticated = () => {
    return fetch(process.env.VUE_APP_ROOT_API_PATH + "api/secure/authentication", {
        method: 'GET',
        credentials: 'include'
    })
        .then((response) => {
            if (response.status === 200) {
                return true;
            } else {
                return false;
            }
        })
        .catch((error) => {
            console.error("Error checking authentication:", error);
            return false;
        });
};
